import { useProperty, useTranslation } from '@eti/providers';
import { analytics } from '@eti/utils';
import { useSelector } from 'react-redux';
import { ancillaryBundle, checkInBaggage } from '../../index';
import getTranslatedTexts from '../../common/text-resolvers/utils/getTranslatedTexts';
import { getSelected, sortOptions } from '../utils/utils';
import Bundle from './bundle/Bundle';
import { jsx as _jsx } from "react/jsx-runtime";
const texts = {
  confirmButtonText: 'Product.Bundle.Confirm.Button.Text',
  noExtrasText: 'Product.Bundle.NoExtras.Text',
  recommendedText: 'Product.Bundle.Recommended.Text',
  selectButtonText: 'Product.Bundle.Select.Button.Text',
  title: 'Product.FlexibleTicket.Bundle.Title'
};
const ProductBundle = ({
  discountPercentage,
  form,
  ancillaryBundleId,
  onChange,
  onConfirm,
  options,
  productPosition,
  shouldShowConfirmationButton,
  travelers
}) => {
  const {
    p
  } = useProperty();
  const {
    t
  } = useTranslation();
  const selectedValue = useSelector(state => getSelected('ancillaryBundle', form)(state));
  const pricePerTraveler = p('Bundle.Overlay.Price.Per.Person.Enabled');
  const priceText = pricePerTraveler ? t('Price.Per.Person') : t('Product.FlexibleTicket.Bundle.Price.Text');
  const discountPercentageTitle = discountPercentage && discountPercentage > 0 ? t('Product.Bundle.DiscountPercentage.Title', discountPercentage) : '';
  const translatedTexts = getTranslatedTexts(texts, t);
  const isBaggageIncludedInBundle = options === null || options === void 0 ? void 0 : options.find(option => {
    var _option$features;
    return 'features' in option && (option === null || option === void 0 || (_option$features = option.features) === null || _option$features === void 0 ? void 0 : _option$features.find(feature => (feature === null || feature === void 0 ? void 0 : feature.productTypeId) === checkInBaggage.id.toString()));
  });
  analytics.useLogMouseFlowTagEffect('Bag-Bundle', Boolean(isBaggageIncludedInBundle));
  const stepNumbers = ['two', 'three', 'four', 'five', 'six', 'seven'];
  const stepRoutes = stepNumbers.map(step => `rf.step.${step}.action`);
  const urls = ['rf.travelerdetails.action', ...stepRoutes];
  const isTDOrStepPage = urls.some(str => window.location.pathname.includes(window.spa_variables.routes[str]));
  return /*#__PURE__*/_jsx(Bundle, {
    ancillaryBundleId: ancillaryBundleId,
    confirmButtonText: translatedTexts.confirmButtonText,
    discountPercentageTitle: discountPercentageTitle,
    isTDOrStepPage: isTDOrStepPage,
    name: ancillaryBundle.name,
    onChange: onChange,
    onConfirm: onConfirm,
    options: sortOptions(options),
    priceText: priceText,
    productPosition: productPosition,
    recommendedText: translatedTexts.recommendedText,
    selectedValue: selectedValue,
    shouldShowConfirmationButton: shouldShowConfirmationButton,
    shouldShowPricePerPerson: pricePerTraveler,
    title: translatedTexts.title,
    travelers: travelers
  });
};
export default ProductBundle;
//# sourceMappingURL=ProductBundle.js.map